import React from 'react';
import { Popup } from '@gravity-ui/uikit';
import { cn } from '../../../../classname';
import { LinkForm } from '../../../../forms/LinkForm';
import { i18n } from '../../../../i18n/widgets';
import './widget.css';
const b = cn('link-placeholder-widget');
const placement = ['bottom-start', 'top-start', 'bottom-end', 'top-end'];
export const LinkPlaceholderWidget = ({ onCancel, onSubmit, }) => {
    const divRef = React.useRef(null);
    return (React.createElement(React.Fragment, null,
        React.createElement("span", { ref: divRef, className: b() },
            React.createElement("a", { href: "#" }, i18n('link'))),
        React.createElement(Popup, { open: true, onClose: onCancel, anchorRef: divRef, placement: placement },
            React.createElement(LinkForm, { autoFocus: true, onSubmit: onSubmit, onCancel: onCancel }))));
};
